// removed by extract-text-webpack-plugin
module.exports = {"modal":"_2_gDlOfcIyVnllC-DAPOKR","failModalContentWrapper":"_2-I9535XDBjBC_QbGLUrcA","failModalTitle":"_3JAHVGKNh2O2-jt3WQTIkk","failModalSubTitle":"_3UZ_zwPkZWqCZEFABJgsA9","failModalButton":"_2WHS3USffMBEMl59ZcitfU"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyStaffContainer/components/ModalError/ModalError.scss
// module id = 1838
// module chunks = 0